import { toRem, toRems } from '../../../../helpers/theme'

const style = ({ theme }) => ({
    position: 'relative',
    margin: toRems([4, 0, 0]),
    padding: toRems([0, 22]),
    fontSize: toRem(14),
    lineHeight: 1.25
})

export default style
